import prop from 'ramda/src/prop'
import { KEYS_AND_CODES_FOR_CREATOR_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { creatorReward, dropKey } from 'root/src/shared/descriptions/endpoints/recordTypes'
import { tableListType } from 'root/src/shared/constants/moduleTypes'
import { VIEW_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import generalRecordModification from 'root/src/client/logic/api/actions/generalRecordModification'
import { rewardEndpointIds } from 'root/src/shared/rewards/constants'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'

export default {
	[KEYS_AND_CODES_FOR_CREATOR_MODULE_ID]: {
		moduleType: 'list',
		listType: tableListType,
		recordType: dropKey,
		endpointId: [rewardEndpointIds.GET_REWARDS_FOR_CREATOR],
		defaultListDataLength: 10,
		isClientPaginated: true,
		listModuleId: KEYS_AND_CODES_FOR_CREATOR_MODULE_ID,
		constantListStoreKey: true,
		listTitle: 'My rewards',
		toggleVisibilityProp: [3],
		headerType: 'backgroundDesign',
		tableColumns: [
			['Name', 'name'],
			['Key/Code', 'rewardData'],
			['Created', 'created'],
			['Restrictions', 'restrictions'],
		],
		tableItemActions: [
			{
				name: () => 'Open',
				fn: item => () => {
					if (!item.url) {
						console.error('No url provided for this reward', item)
						return
					}
					window.open(addHttpsProtocol(item.url), '_blank', 'noopener,noreferrer')
				},
				hide: item => !item?.url,
				header: 'Asset',
				order: 0,
			},
			{
				name: prop('projectTitle'),
				fn: item => () => pushRouteClient({
					routeId: VIEW_PROJECT_ROUTE_ID,
					routeParams: { recordId: item.projectUrl },
				}),
				header: 'Source',
				order: 1,
			},
			{
				value: prop('rewardUsed'),
				fn: item => async (dispatch, getState) => {
					const { rewardData, rewardUsed } = item
					const isRewardUsed = rewardUsed ? !rewardUsed : true

					dispatch(
						generalRecordModification({}, [
							{
								modification: 'set',
								path: [creatorReward, rewardData, 'rewardUsed'],
								value: isRewardUsed,
							},
						]),
					)

					const state = getState()

					const records = [{ sk: item.sk, rewardUsed: isRewardUsed }]
					await invokeApiRequest(rewardEndpointIds.SET_DROP_DELIVERED_REWARDS_USED, { records }, state)
				},
				header: 'Key Used?',
				type: 'checkbox',
				centered: true,
			},
		],
	},
}
